import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row, Input } from "reactstrap"; // Import Input from reactstrap for better styling
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";

function AddEdit_ProductRateMaster() {
  const API_URL = API_WEB_URLS.MASTER + "/0/token/ItemType";
  const API_URL1 = API_WEB_URLS.MASTER + "/0/token/Product";
  const API_URL2 = API_WEB_URLS.MASTER + "/0/token/Weight";
  const API_URL_SAVE = "ProductMasterL/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/ProductRateEdit/Id";

  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    FillArray1: [],
    FillArray2: [],
    formData: {},
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate()
  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FillArray", API_URL + "/Id/0");
    Fn_FillListData(dispatch, setState, "FillArray1", API_URL1 + "/Id/0");
    Fn_FillListData(dispatch, setState, "FillArray2", API_URL2 + "/Id/0");

    const Id = (location.state && location.state.Id) || 0;

    if (Id > 0) {
      setState((prevState) => ({
        ...prevState,
        id: Id,
      }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  // Validation Schema
  const validationSchema = Yup.object({
    F_ProductMaster: Yup.number().required("Product is required"),
    F_ItemTypeMaster: Yup.number().required("Brand is required"),
    F_WeightCategory: Yup.number().required("Weight Category is required"),
    Rate: Yup.number().required("Rate is required").positive("Rate must be a positive number"),
  });

  // Handle Submit
  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    let formData = new FormData();
    formData.append("F_ProductMaster", values.F_ProductMaster);
    formData.append("F_ItemTypeMaster", values.F_ItemTypeMaster);
    formData.append("F_WeightCategory", values.F_WeightCategory);
    formData.append("Rate", values.Rate);
    formData.append("UserId", obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
        navigate,
      "/ProductRateMaster"
    );
  };

  return (
    <div className="page-content">
      <Formik
        initialValues={{
          ...state.formData,
          F_ProductMaster: state.formData.F_ProductMaster || -1,
          F_ItemTypeMaster: state.formData.F_ItemTypeMaster || -1,
          F_WeightCategory: state.formData.F_WeightCategory || -1,
          Rate: state.formData.Rate || "",
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
            {/* Brand Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="F_ItemTypeMaster" className="form-label">
                  Brand
                </label>
              </Col>
              <Col lg="6" className="mb-3">
                <Input
                  type="select"
                  name="F_ItemTypeMaster"
                  onChange={(e) => setFieldValue("F_ItemTypeMaster", e.target.value)}
                  value={values.F_ItemTypeMaster}
                >
                  <option value={-1}>Select Brand</option>
                  {state.FillArray.map((type) => (
                    <option key={type.Id} value={type.Id}>
                      {type.Name}
                    </option>
                  ))}
                </Input>
                <ErrorMessage name="F_ItemTypeMaster" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Product Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="F_ProductMaster" className="form-label">
                  Product
                </label>
              </Col>
              <Col lg="6" className="mb-3">
                <Input
                  type="select"
                  name="F_ProductMaster"
                  onChange={(e) => setFieldValue("F_ProductMaster", e.target.value)}
                  value={values.F_ProductMaster}
                >
                  <option value={-1}>Select Product</option>
                  {state.FillArray1.map((type) => (
                    <option key={type.Id} value={type.Id}>
                      {type.Name}
                    </option>
                  ))}
                </Input>
                <ErrorMessage name="F_ProductMaster" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Weight Category Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="F_WeightCategory" className="form-label">
                  Weight Category
                </label>
              </Col>
              <Col lg="6" className="mb-3">
                <Input
                  type="select"
                  name="F_WeightCategory"
                  onChange={(e) => setFieldValue("F_WeightCategory", e.target.value)}
                  value={values.F_WeightCategory}
                >
                  <option value={-1}>Select Weight Category</option>
                  {state.FillArray2.map((type) => (
                    <option key={type.Id} value={type.Id}>
                      {type.Name}
                    </option>
                  ))}
                </Input>
                <ErrorMessage name="F_WeightCategory" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Rate Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="Rate" className="form-label">
                  Rate
                </label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field
                  className="form-control"
                  type="number"
                  name="Rate"
                  placeholder="Enter Rate"
                  min="0"
                  step="any"
                />
                <ErrorMessage name="Rate" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Submit Button */}
            <button type="submit" className="btn btn-primary btn-block">
              Submit
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddEdit_ProductRateMaster;
